import * as yup from 'yup'
import FormSchema from 'src/base/Form/Schemas'
import TYPES from 'src/configs/Fields'

export const touchAfterReload = [
  'emails[0].email',
  'establishmentId'
]

const disabledBy = ['DISABLED_RUC']

export function buildFormSchema(dependencies) {
  const { intl, person: { businessModel: { isCollaborator, isACT, isFinalConsumer } } } = dependencies
  const shouldShowEstablishment = isCollaborator || isACT

  const DOCUMENTS = commonParams({ ...TYPES.DOCUMENTS(intl, dependencies), disabledBy })
  const RUC = commonParams(TYPES.RUC(intl, dependencies), false)
  const NAME_FIRST = commonParams(TYPES.NAME_FIRST(intl, dependencies))
  const NAME_LAST = commonParams(TYPES.NAME_LAST(intl, dependencies))
  const NAME_MESSAGE = TYPES.NAME_MESSAGE(intl, dependencies)
  const GENDER = commonParams(TYPES.GENDER(intl, dependencies))
  const BIRTHDAY = commonParams(TYPES.BIRTHDAY(intl, dependencies))
  const ESTABLISHMENT = commonParams(TYPES.ESTABLISHMENT(intl, dependencies))
  const ADMISSION = commonParams(TYPES.ADMISSION(intl, dependencies))
  const NATIONALITY = commonParams(TYPES.NATIONALITY(intl, dependencies))
  const PHONES = commonParams(TYPES.PHONES(intl, dependencies))
  const EMAIL = emailParams(commonParams(TYPES.EMAIL(intl, dependencies), false))
  const EMAIL_REQUIRED = commonParams(TYPES.EMAIL(intl, dependencies))

  const fieldsSchema = [
    [DOCUMENTS],
    [RUC],
    [NAME_FIRST, NAME_LAST],
    [NAME_MESSAGE],
    [GENDER, BIRTHDAY],
    shouldShowEstablishment ? [ESTABLISHMENT, ADMISSION] : [],
    [NATIONALITY],
    isFinalConsumer ? [EMAIL] : [EMAIL_REQUIRED],
    [PHONES]
  ]

  return new FormSchema({ fieldsSchema, name: 'BasicPersonalInfo' })
}

function commonParams(field, required = true) {
  return {
    ...field,
    required
  }
}

function emailParams(field) {
  return {
    ...field,
    validations: yup.array().of(yup.object().shape({
      email: yup.string().lowercase().email()
    }))
  }
}
